import Home from './Home'
import store from '@/store'
import { get } from 'axios'
import { API_ENDPOINT_BASE, ROOT } from '@/constans'
import swal from 'sweetalert2'
import { LOADING, PREVIEWS } from '@/store/mutations'

export default [
  {
    path: '/avances',
    name: 'previews',
    component: Home,
    beforeEnter (to, from, next) {
      store.commit(LOADING, true, ROOT)
      get(API_ENDPOINT_BASE + '/previews')
        .then(({ data }) => {
          store.commit(PREVIEWS, data)
          next()
        })
        .catch(error => {
          swal({ html: error.response.data.msg, type: 'error' })
          store.commit(PREVIEWS, [])
        })
        .finally(() => {
          store.commit(LOADING, false, ROOT)
        })
    }
  }
]
